var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "限时审批",
        visible: _vm.visible,
        width: "552px",
        "append-to-body": true,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "fix-form" },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "check-group",
              model: {
                value: _vm.timeLimitedApproval.timeoutAction,
                callback: function ($$v) {
                  _vm.$set(_vm.timeLimitedApproval, "timeoutAction", $$v)
                },
                expression: "timeLimitedApproval.timeoutAction",
              },
            },
            [
              _c("el-radio", { attrs: { label: "autoApprove" } }, [
                _c(
                  "span",
                  { staticClass: "name-text" },
                  [
                    _vm._v("超过 "),
                    _c(
                      "el-select",
                      {
                        staticClass: "time-select",
                        attrs: { placeholder: "请选择", size: "mini" },
                        model: {
                          value: _vm.time1,
                          callback: function ($$v) {
                            _vm.time1 = $$v
                          },
                          expression: "time1",
                        },
                      },
                      _vm._l(_vm.timeList, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                    _vm._v("小时未处理，系统自动设置审批人通过"),
                  ],
                  1
                ),
              ]),
              _c("el-radio", { attrs: { label: "autoReject" } }, [
                _c(
                  "span",
                  { staticClass: "name-text" },
                  [
                    _vm._v("超过 "),
                    _c(
                      "el-select",
                      {
                        staticClass: "time-select",
                        attrs: { placeholder: "请选择", size: "mini" },
                        model: {
                          value: _vm.time2,
                          callback: function ($$v) {
                            _vm.time2 = $$v
                          },
                          expression: "time2",
                        },
                      },
                      _vm._l(_vm.timeList, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                    _vm._v("小时未处理，系统自动设置审批人拒绝"),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }